import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const CancelButton = styled(Button)(({ theme }) => ({
    color: '#E41324',
    height: '3.12rem',
    padding: '1rem',
    backgroundColor: 'transparent',
    borderRadius: '0.5rem',
    '&:hover': {
    backgroundColor: 'transparent',
    }
}));

export default CancelButton;